import {LoadingOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import cn from 'classnames';
import {isNil} from 'lodash-es';
import React, {FC} from 'react';

import {IconsMap} from 'components/dynamic-icon';
import {UIBlocker} from 'components/ui-blocker';
import {useCustomLinkHandler} from 'features/provide-custom-link/hooks/use-custom-link-handler';
import {TLinkDto} from 'shared/types/links';

interface IViewPudButtonProps {
    link: TLinkDto;
}

export const ViewPudButton: FC<IViewPudButtonProps> = ({link}: IViewPudButtonProps) => {
    const {handleLinkClick, checkIsLoading} = useCustomLinkHandler({link});

    const hasLinkAction = !isNil(link);

    return (
        <UIBlocker
            childrenClassName="d-flex"
            content={checkIsLoading && checkIsLoading() ? (
                <div>
                    <LoadingOutlined />
                </div>
            ) : undefined}
        >
            <Tooltip
                mouseEnterDelay={0.7}
                placement="right"
                title="Просмотреть ПУД"
            >
                <IconsMap.Document
                    onClick={() => {
                        if (hasLinkAction) {
                            handleLinkClick();
                        }
                    }}
                    className={cn(
                        'ais-documents-register-table__pud-button',
                        {'ais-documents-register-table__pud-button_disabled': !hasLinkAction},
                    )}
                />
            </Tooltip>
        </UIBlocker>
    );
};
